import { AIToolMetadata, ToolExecution } from './tool.types';

type ToolDefault = {
  name: string;
  description: string;
  execution: ToolExecution;
  metadata: AIToolMetadata;
};

const tools: ToolDefault[] = [
  {
    name: 'Bucket Search',
    description:
      'Similarity search one or many Telnyx buckets and rank the results. You can change the search method to fit your usecase (quality/speed).',
    execution: ToolExecution.BUCKET_SEARCH,
    metadata: {
      search_descriptor: '',
      max_results: 10,
      max_tokens: 4000,
      backup_output: '',
      backup_tool_choice: '',
      bucket_search_type: 'list_and_search',
      indexes: [],
    },
  },
  {
    name: 'Bucket Retrieval',
    description: 'Perform a similarity search across many Telnyx buckets.',
    execution: ToolExecution.BUCKET_RETRIEVAL,
    metadata: {
      bucket_ids: [],
      max_num_results: 5,
    },
  },
  {
    name: 'Static Document',
    description:
      'Format static content to be read after executing this tool. Useful for providing instructions or context.',
    execution: ToolExecution.STATIC_DOCUMENT,
    metadata: {
      output: '',
    },
  },
  {
    name: 'HTTP Request',
    description: 'Send a HTTP request and use the response as the tool output.',
    execution: ToolExecution.HTTP_REQUEST,
    metadata: {
      method: 'get',
      url: '',
      query_parameters: [],
      header_parameters: [],
      body_format: 'form',
      body_parameters: [],
      body_json: `{\n   "example": "{{ tool.args.example }}"\n}`,
      auth_enabled: 'false',
      auth_secret_name: '',
      approval_required: 'false',
    },
  },
  {
    name: 'Telnyx API Search',
    description: 'Search the Telnyx API documentation for relevant endpoints, parameters, responses and webhooks.',
    execution: ToolExecution.TELNYX_API_SEARCH,
    metadata: {
      search_descriptor: '',
      bucket_search_type: 'list_and_search',
      max_tokens: 4000,
      max_results: 10,
      query_parameters: 'false',
      body_parameters: 'false',
      responses: 'false',
      webhooks: 'false',
      sdk: 'none',
      backup_output: '',
      backup_tool_choice: '',
    },
  },
  {
    name: 'Hangup Call',
    description: 'Terminate a call when this tool is executed.',
    execution: ToolExecution.HANGUP_CALL,
    metadata: undefined,
  },
  {
    name: 'Telnyx Pricing',
    description: 'Search for basic Telnyx pricing information for each product.',
    execution: ToolExecution.TELNYX_PRICING_CALCULATOR,
    metadata: {
      product: '',
      countryCode: '',
    },
  },
];

export const getToolDefault = (execution: ToolExecution): ToolDefault => {
  const tool = tools.find((tool) => tool.execution === execution);
  if (tool) return tool;

  return {
    name: execution,
    description: 'No description available for this tool.',
    execution,
    metadata: undefined,
  };
};
